import { FC } from 'react'

interface IFNewsSliderArrowRightProps {
  isShow: boolean
}

const NewsSliderArrowRight: FC<IFNewsSliderArrowRightProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      aria-label="소식 슬라이더 오른쪽 화살표"
      display={props.isShow ? 'block' : 'none'}
    >
      <desc>소식 슬라이더 오른쪽 화살표</desc>
      <defs>
        <filter
          id="679do00p5a"
          width="44"
          height="44"
          x="0"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2"></feOffset>
          <feGaussianBlur result="blur" stdDeviation="2"></feGaussianBlur>
          <feFlood floodOpacity="0.161"></feFlood>
          <feComposite in2="blur" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
      </defs>
      <g opacity="0.5">
        <g data-name="그룹 11003" filter="url(#679do00p5a)">
          <circle
            cx="16"
            cy="16"
            r="16"
            fill="#fff"
            data-name="타원 1028"
            transform="rotate(180 19 18)"
          ></circle>
        </g>
        <path
          fill="none"
          stroke="#333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19.495 26.075l7.008-6.076-7.008-6.076"
          data-name="패스 7992"
        ></path>
      </g>
    </svg>
  )
}

export default NewsSliderArrowRight
